import { CheckCircleOutline } from '@mui/icons-material'
import { createTheme } from '@mui/material/styles'

import blueLight from 'utils/colors/blueLight'

export default createTheme({
  typography: {
    h1: {
      fontSize: '2.25rem',
      fontStyle: 'normal',
      fontWeight: 900,
      lineHeight: '144.44%',
      letterSpacing: '0',
    },
    h2: {
      fontSize: '1.75rem',
      fontStyle: 'normal',
      fontWeight: 900,
      lineHeight: '157.44%',
      letterSpacing: '0',
    },
    h3: {
      fontSize: '1.5rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '142.66%',
      letterSpacing: '0',
    },
    h4: {
      fontSize: '1.312rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '133.33%',
      letterSpacing: '0',
    },
    h5: {
      fontSize: '1.125rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '144.44%',
      letterSpacing: '0',
    },
    h6: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '160%',
      letterSpacing: '0',
    },
    subtitle1: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '175%',
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontSize: '.875rem',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '157%',
      letterSpacing: '0.1px',
    },
    body1: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '150%',
      letterSpacing: '0.15px',
    },
    body2: {
      fontSize: '.875rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '143%',
      letterSpacing: '0.15px',
    },
    caption: {
      fontSize: '.75rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '166%',
      letterSpacing: '0.4px',
    },
  },
  palette: {
    primary: {
      vivid: blueLight[600],
      ghost: blueLight[100],
      light: blueLight[400],
      main: blueLight[600],
      dark: blueLight[800],
    },
    secondary: {
      light: '#668e9b',
      main: blueLight.A200,
      dark: blueLight.A100,
    },
    text: {
      primary: '#212121',
      secondary: '#666',
      disabled: '#9e9e9e',
      highlight: '#276DB7',
    },
    colors: {
      buttons: {
        container: {
          background: blueLight[600],
          color: '#FFFFFF',
          hover: blueLight[800],
        },
      },
      anchor: '#1c242b',
      avatar: blueLight[600],
      avatarText: '#FFF',

      btnDisabled: 'rgba(0, 0, 0, 0.12)',
      btnColorDisabled: 'rgba(0, 0, 0, 0.26)',

      commentEmails: '#757575',

      buttonGroup: '#fff',
      buttonGroupBg: 'transparent',

      activeIcon: blueLight[600],
      icon: '#757575',

      disabled: '#BEBEBE',

      selected: blueLight[300],
      selectedIcon: blueLight[600],

      buttonAction: blueLight[600],

      infoColor: blueLight.A50,

      ticketIcon: blueLight.A200,
      border: '#E8E8E8',
      headerDividerTicket: '#E0E0E0',
      secBorder: '#CCC',

      lightGrey: '#9E9E9E',
      textOver: '#f9f9f9',
      inputBg: 'rgba(145, 156, 167, 0.12)',
      inputSearchBg: 'rgba(145, 156, 167, 0.12)',

      mainText: '#000000',
      secondaryText: '#666666',
      secText: '#000',
      quartText: '#000',
      detailsText: '#757575',

      skelPrimary: 'rgb(236, 238, 240)',
      skelSecondary: 'rgb(236, 238, 240)',

      iframeBg: '#FFF',
      notification: '#FFF',
      slaCardWarning: 'rgba(253, 237, 211, 0.8)',
      ripple: 'rgba(0, 0, 0, 0.24)',

      // specific colors
      attachmentsFileName: blueLight.A500,
      attachmentsFileSize: '#757575',

      chipSecondaryUnification: '#80A1AC',
    },

    // V5 theme
    type: 'light',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: '#FFF',
          backgroundColor: '#00AEEF',
          '&:hover': { backgroundColor: '#0383b3' },
        },
        containedSecondary: {
          color: '#00AEEF',
          backgroundColor: 'rgba(0, 174, 239, 0.11)',
          '&:hover': { backgroundColor: 'rgba(0, 174, 239, 0.21)' },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        text: {
          fill: '#FFF',
        },
      },
    },
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          success: <CheckCircleOutline />,
        },
      },
      styleOverrides: {
        filledSuccess: {
          backgroundColor: '#60BB46',
          maxWidth: '30rem',
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
  },
})
